'use client';

export default function RadioButton({ id, label, value, field }) {
  return (
    <label htmlFor={id} className="flex items-center gap-2 cursor-pointer select-none text-xs text-[#383838] dark:text-white whitespace-nowrap">
      <div className="relative flex items-center">
        <input id={id} name={field.name} type="radio" value={value} checked={field.value === value} onChange={() => field.onChange(value)} onBlur={field.onBlur} ref={field.ref} className="sr-only" />
        <div
          className={`flex h-4 w-4 items-center justify-center rounded-full border ${field.value === value ? '!border-5 border-[#1F8022] dark:bg-white' : 'border-[#38383833] dark:border-[#a5a5a5]'}`}
        ></div>
      </div>
      <span className="whitespace-nowrap">{label}</span>
    </label>
  );
}
